/**
 * Design System Test Page
 * Tests importing components directly from components/ui
 */

import { PageContainer } from '../components/PageContainer';
import { Button as DSButton } from '../components/ui/Button';

export const DesignSystemTest = () => {
  return (
    <PageContainer variant="white" className="space-y-8">
      <div>
        <h1 className="text-4xl font-bold">Design System Test</h1>
        <p className="text-gray-600 mt-2">
          Testing components from components/ui
        </p>
      </div>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold">Design System Button</h2>
        <div className="flex flex-wrap gap-4">
          <DSButton variant="primary">Primary</DSButton>
          <DSButton variant="secondary">Secondary</DSButton>
          <DSButton variant="outline">Outline</DSButton>
          <DSButton variant="ghost">Ghost</DSButton>
          <DSButton variant="link">Link</DSButton>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold">Button Sizes</h2>
        <div className="flex flex-wrap items-center gap-4">
          <DSButton size="sm">Small</DSButton>
          <DSButton size="md">Medium</DSButton>
          <DSButton size="lg">Large</DSButton>
          <DSButton size="xl">Extra Large</DSButton>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold">Button States</h2>
        <div className="flex flex-wrap gap-4">
          <DSButton loading>Loading</DSButton>
          <DSButton disabled>Disabled</DSButton>
          <DSButton fullWidth>Full Width</DSButton>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold">Comparison</h2>
        <div className="flex gap-4 items-center">
          <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700">
            Regular Tailwind Button
          </button>
          <DSButton variant="primary">Design System Button</DSButton>
        </div>
        <p className="text-sm text-gray-500">
          The design system button uses primary-600 (wine red) from the design tokens.
          If it appears unstyled, the Tailwind content paths may not be scanning the design system.
        </p>
      </section>
    </PageContainer>
  );
};
